<template>
    <div class="company-analysis-index">
        <div class="company-analysis-index_header">
            <div class="header-logo">
                <img src="@/assets/images/training/company-analysis/logo.svg" alt="" />
            </div>

            <div class="header-menu">
                <div :class="['menu-item', { 'is-check': item.id === currentMenu }]" v-for="item in menuList" :key="item.id">
                    {{ item.label }}
                </div>
            </div>

            <div class="header-empty"></div>

            <div class="header-task">
                <!-- <div class="task-button">实训任务</div> -->
            </div>

            <div class="header-comment">
                <i class="iconfont">&#xe616;</i>
                私信
            </div>

            <div class="header-user">
                <img src="../../../assets/images/training-logo.png" alt="" class="user-img" />

                <div class="user-info">
                    <div class="user-info_top">一课教育</div>
                    <div class="user-info_cert"><i class="iconfont">&#xe63b;</i> 已认证</div>
                </div>
            </div>
        </div>

        <div class="company-analysis-index_box">
            <div class="box-menu">
                <div
                    :class="['menu-item', { 'is-check': item.id === $route.meta.routerId }]"
                    v-for="item in routerOptions"
                    :key="item.id"
                    @click="handleCheckMenu(item)"
                >
                    <i class="iconfont">
                        {{ formatIconfont(item.icon) }}
                    </i>
                    {{ item.label }}
                </div>
            </div>

            <div class="box-content">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CompanyAnalysis",
    data() {
        return {
            currentMenu: 2,
            menuList: [
                { id: 1, label: "运营工作台" },
                { id: 2, label: "数据分析" },
                { id: 3, label: "商家学堂" },
                { id: 4, label: "创意灵感" },
                { id: 5, label: "服务市场" },
                { id: 6, label: "推广营销" },
            ],

            routerOptions: [
                { id: 1, label: "综合概览", icon: "&#xe607;", routerPath: "/training/company/general" },
                { id: 2, label: "场景运营数据", icon: "&#xe9d2;", routerPath: "/training/company/scene" },
                { id: 3, label: "粉丝数据", icon: "&#xe645;", routerPath: "/training/company/fan" },
                { id: 4, label: "经营数据", icon: "&#xe72c;", routerPath: "/training/OperatingData" },
                { id: 5, label: "用户数据", icon: "&#xe604;", routerPath: "/training/UserData" },
            ],
        };
    },
    methods: {
        handleCheckMenu(item) {
            if (!item.routerPath) return;

            this.$router.push({
                path: item.routerPath,
                query: {
                    data_type: this.$route.query.data_type,
                    project_id: this.$route.query.project_id,
                },
            });
        },

        // 将iconfont字符串转化为unicode
        formatIconfont(icon) {
            const reg = new RegExp(/(&#x)?(.*)/);
            let iconfontName = "";
            if (reg.test(icon)) {
                iconfontName = reg.exec(icon)[2];
            }

            return String.fromCharCode(parseInt(iconfontName, 16));
        },
    },
    created() {
        const data_type = Number(this.$route.query.data_type);
        const dataTypeMap = new Map([
            [10, this.routerOptions[0]],
            [11, this.routerOptions[1]],
            [12, this.routerOptions[2]],
            [13, this.routerOptions[3]],
            [14, this.routerOptions[4]],
        ]);

        const currentRoute = dataTypeMap.get(data_type);
        if (currentRoute && currentRoute.routerPath) {
            this.$router.push({
                path: dataTypeMap.get(data_type).routerPath,
                query: {
                    data_type: this.$route.query.data_type,
                    project_id: this.$route.query.project_id,
                },
            });
        }
    },
};
</script>

<style lang="scss" scoped>
.company-analysis-index {
    width: 100vw;
    height: 100vh;
    // background-color: #ffffff;
    background: radial-gradient(100% 157.26% at 0 0, #d9f2ff99 0, #f2f0fc99 27.87%, #bfd8ff99);

    &_header {
        height: 64px;
        // background-color: rgba(0, 0, 0, 0.2);
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-inline: 24px;

        .header-menu {
            display: flex;
            gap: 24px;
            color: #333333;
            margin-left: 30px;

            .menu-item {
                position: relative;
                cursor: pointer;

                &.is-check {
                    color: #2a55e5;
                    font-weight: 600;

                    &::before {
                        position: absolute;
                        content: "";
                        width: 20px;
                        height: 3px;
                        border-radius: 3px;
                        background-color: #2a55e5;
                        bottom: -10px;
                        left: 50%;
                        transform: translateX(-50%);
                    }
                }
            }
        }

        .header-empty {
            flex: 1;
        }

        .header-task {
            .task-button {
                background-color: #2a55e5;
                padding: 6px 20px;
                text-align: center;
                color: #ffffff;
                cursor: pointer;
                border-radius: 4px;
                margin-right: 40px;
            }
        }

        .header-comment {
            color: #969aa0;
            line-height: 16px;
        }

        .header-user {
            display: flex;
            align-items: center;
            gap: 2px;
            margin-left: 60px;
            padding-right: 40px;

            .user-img {
                width: 32px;
                height: 32px;
                object-fit: cover;
                border-radius: 50%;
                background-color: #ffffff;
            }

            .user-info {
                font-size: 12px;
                width: 60px;
                text-align: right;

                &_cert {
                    color: #999999;

                    .iconfont {
                        font-size: 12px;
                        color: #2a55e5;
                    }
                }
            }
        }
    }

    &_box {
        height: calc(100vh - 64px);
        box-sizing: border-box;
        display: flex;

        .box-menu {
            width: 200px;
            height: 100%;
            box-sizing: border-box;
            padding-left: 15px;

            .menu-item {
                height: 40px;
                display: flex;
                align-items: center;
                gap: 10px;
                padding-left: 10px;
                box-sizing: border-box;
                border-radius: 4px;
                margin-top: 10px;
                cursor: pointer;

                .iconfont {
                    color: #969aa0;
                }

                &.is-check {
                    background-color: #ffffff;
                    color: #2a55e5;
                    font-weight: 600;

                    .iconfont {
                        color: #2a55e5;
                    }
                }
            }
        }

        .box-content {
            width: calc(100% - 200px);
            height: 100%;
            // background-color: blue;
            overflow: hidden;
        }
    }
}
</style>
